import * as Yup from 'yup';
import { DictionaryOvss } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryOvss>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
